<div *ngIf="!mobileQuery.matches; else mobileSetting" class="settings">
    <button id="settings-button" mat-icon-button (click)="snav.toggle()">
        <mat-icon *ngIf="!settingsButtonOutline" aria-label="Settings">settings</mat-icon>
        <mat-icon *ngIf="settingsButtonOutline" fontSet="material-icons-outlined" aria-label="Settings"
            >settings</mat-icon
        >
    </button>
    <mat-sidenav-container class="sidenav-container" [hasBackdrop]="true">
        <mat-sidenav
            #snav
            mode="over"
            position="end"
            [fixedInViewport]="!mobileQuery.matches"
            fixedTopGap="64"
            class="vertical-menu"
        >
            <mat-nav-list class="mat-nav-list text-wrap">
                <div class="title">
                    <span>Settings</span>
                </div>
                @if (customerServiceInfo) {
                    <app-customer-service class="customer-service" />
                }
                <div class="info-container">
                    <span class="info-title">Legal</span>
                    <div class="info-text">
                        <a
                            id="privacy-policy-link"
                            (click)="snav.toggle()"
                            [href]="privacyAndPolicyURL | sanitize: 'url'"
                            target="_blank"
                            class="link-settings text-item text-capitalize"
                        >
                            Privacy policy
                            <mat-icon aria-label="Privacy policy" class="md-icon-18"> launch </mat-icon>
                        </a>
                        <a
                            id="terms-of-use-link"
                            (click)="snav.toggle()"
                            *ngIf="termsOfUseExternal; else internalLink"
                            [href]="termsOfUseURL | sanitize: 'url'"
                            target="_blank"
                            class="link-settings text-item text-capitalize"
                            tabindex="0"
                        >
                            Terms of use
                            <mat-icon aria-label="terms of use" class="md-icon-18"> launch </mat-icon>
                        </a>
                        <ng-template #internalLink>
                            <a
                                id="terms-of-use-internal-link"
                                (click)="snav.toggle(); navigateToTermsOfUse()"
                                class="link-settings mat-body-2 text-item d-flex justify-content-between p-0 text-capitalize"
                                tabindex="0"
                            >
                                Terms of use
                                <mat-icon aria-label="terms of use" class="md-icon-18"> launch </mat-icon>
                            </a>
                        </ng-template>
                    </div>
                </div>
                @if (isDarkModeEnable) {
                    <div class="info-container">
                        <span class="info-title">Appearance</span>
                        <div class="info-base">
                            <mat-radio-group id="theme-selection-group" class="d-grid" [formControl]="initialTheme">
                                <mat-radio-button
                                    [id]="'theme-option-' + op.id"
                                    *ngFor="let op of listTheme"
                                    [value]="op.id"
                                    (change)="radioChange($event.value); snav.toggle()"
                                    [checked]="op.checked"
                                    class="mat-body-2 mb-3"
                                    >{{ op.name }}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                }

                <lib-system-info></lib-system-info>
            </mat-nav-list>
        </mat-sidenav>
    </mat-sidenav-container>
</div>
<ng-template #mobileSetting>
    <a
        mat-list-item
        [href]="privacyAndPolicyURL | sanitize: 'url'"
        target="_blank"
        routerLinkActive="router-link-active"
    >
        <mat-icon aria-label="Search" class="md-icon-18">launch</mat-icon>
        PRIVACY POLICY
    </a>
    <a
        mat-list-item
        *ngIf="termsOfUseExternal; else internalLink"
        [href]="termsOfUseURL | sanitize: 'url'"
        target="_blank"
        routerLinkActive="router-link-active"
        tabindex="0"
    >
        <mat-icon aria-label="Search" class="md-icon-18">launch</mat-icon>
        TERMS OF USE
    </a>
    <ng-template #internalLink>
        <a
            id="terms-of-use-internal"
            mat-list-item
            (click)="navigateToTermsOfUse()"
            routerLinkActive="router-link-active"
            tabindex="0"
        >
            <mat-icon aria-label="Search" class="md-icon-18">launch</mat-icon>
            TERMS OF USE
        </a>
    </ng-template>
    @if (isDarkModeEnable) {
        <a mat-list-item class="settings">
            <mat-icon aria-label="Search" class="md-icon-18"> brightness_6 </mat-icon>
            <a [matMenuTriggerFor]="menu">APPEARANCE</a>
            <mat-menu #menu="matMenu">
                <mat-radio-group class="d-grid p-3" [formControl]="initialTheme">
                    @for (op of listTheme; track $index) {
                        <mat-radio-button
                            [value]="op.id"
                            (change)="radioChange($event.value)"
                            [checked]="op.checked"
                            class="mat-body-2 settings-radio-button"
                            >{{ op.name }}
                        </mat-radio-button>
                    }
                </mat-radio-group>
            </mat-menu>
        </a>
    }
</ng-template>
